








import Vue from 'vue';
import {Page,PageRenderer} from '../domain/page';

class Vue2PageRenderer implements PageRenderer{
    el:HTMLElement
    innerEl:HTMLElement
    page:Page|undefined
    numIntents=0
    isOverflown(): Promise<boolean> {
        return new Promise((resolve,reject)=>{
            Vue.nextTick (()=>{
                // Detección simple y estable: scrollHeight vs clientHeight con margen fijo
                const outerH = this.el.clientHeight; // altura usable sin bordes
                const innerH = this.innerEl.scrollHeight; // contenido total
                const safety = 32; // margen de seguridad para evitar cortes visuales
                const bottomSlack = 32; // reserva extra para "Página x de y" y respiro visual
                resolve(innerH > (outerH - safety - bottomSlack));
            })
            
        })
    }
    
    setPage(page: Page): void{
        this.page=page
        this.page.setRenderer(this)
    }
    constructor(el:HTMLElement,innerEl:HTMLElement){
        this.el=el
        this.innerEl=innerEl
    }
}

export default {
    name: 'ReportPage',
    props:{
        page: {
            type: Object,
            required: true,
        },
        num_page: {
            type: Number,
            required: true,
        },
        total_pages: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            rootElement: null,
            innerElement: null,
            renderer: null,
        };
    },
    mounted() {
        this.rootElement = this.$refs.rootElement;
        this.innerElement = this.$refs.innerElement;
        if(this.rootElement && this.innerElement){
            this.renderer = new Vue2PageRenderer(this.rootElement, this.innerElement);
            this.renderer.setPage(this.page as Page);
        }
    },
};
